module.exports = __webpack_public_path__ + "static/img/Brent.Prismall.04fd084.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Brent.Prismall.jpg
// module id = j5zJ
// module chunks = 0